"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var BrandsSmsCfgCtl = /** @class */ (function (_super) {
    __extends(BrandsSmsCfgCtl, _super);
    function BrandsSmsCfgCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this._errDialog = errDialog;
        return _this;
    }
    BrandsSmsCfgCtl.prototype.ResetData = function () {
        this.DATA = {
            sms_api_url: "",
            sms_api_key: "",
            sms_login: "",
            sms_password: "",
            sms_provider_type_code: 0,
            sms_provider_type_title: "",
            is_limit_sms_by_single_ip: false,
            limit_sms_count_short: 0,
            limit_sms_interval_min_short: 0,
            limit_sms_count_long: 0,
            limit_sms_interval_min_long: 0,
            allow_registration_by_phone: false
        };
    };
    BrandsSmsCfgCtl.prototype.LoadData = function (brand_key, onDone) {
        var _this = this;
        webAApi_1.DetailsBrandSmsConfigGet.exec({ brand_id: brand_key }, function (resp) {
            _this.DATA.sms_api_url = resp.sms_api_url;
            _this.DATA.sms_api_key = resp.sms_api_key;
            _this.DATA.sms_login = resp.sms_login;
            _this.DATA.sms_password = resp.sms_password;
            _this.DATA.sms_provider_type_code = resp.sms_provider_type_code;
            _this.DATA.sms_provider_type_title = resp.sms_provider_type_title;
            _this.DATA.is_limit_sms_by_single_ip = resp.is_limit_sms_by_single_ip;
            _this.DATA.limit_sms_count_short = resp.limit_sms_count_short;
            _this.DATA.limit_sms_interval_min_short = resp.limit_sms_interval_min_short;
            _this.DATA.limit_sms_count_long = resp.limit_sms_count_long;
            _this.DATA.limit_sms_interval_min_long = resp.limit_sms_interval_min_long;
            _this.DATA.allow_registration_by_phone = resp.allow_registration_by_phone;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BrandsSmsCfgCtl.prototype.EditData = function (editData, onDone) {
        var _this = this;
        webAApi_1.DoEditBrandSmsConfig.exec({
            data: {
                sms_api_url: editData.sms_api_url,
                sms_api_key: editData.sms_api_key,
                brand_id: editData.brand_id,
                sms_login: editData.sms_login,
                sms_password: editData.sms_password,
                sms_provider_type_code: editData.sms_provider_type_code,
                //sms_provider_type_title: editData.sms_provider_type_title,
                is_limit_sms_by_single_ip: editData.is_limit_sms_by_single_ip,
                limit_sms_count_short: editData.limit_sms_count_short,
                limit_sms_interval_min_short: editData.limit_sms_interval_min_short,
                limit_sms_count_long: editData.limit_sms_count_long,
                limit_sms_interval_min_long: editData.limit_sms_interval_min_long,
                allow_registration_by_phone: editData.allow_registration_by_phone
            }
        }, function (resp) {
            _this.DATA.sms_api_url = editData.sms_api_url;
            _this.DATA.sms_api_key = editData.sms_api_key;
            _this.DATA.sms_login = editData.sms_login;
            _this.DATA.sms_password = editData.sms_password;
            _this.DATA.sms_provider_type_code = editData.sms_provider_type_code;
            _this.DATA.sms_provider_type_title = resp.sms_provider_type_title;
            _this.DATA.is_limit_sms_by_single_ip = editData.is_limit_sms_by_single_ip;
            _this.DATA.limit_sms_count_short = editData.limit_sms_count_short;
            _this.DATA.limit_sms_interval_min_short = editData.limit_sms_interval_min_short;
            _this.DATA.limit_sms_count_long = editData.limit_sms_count_long;
            _this.DATA.limit_sms_interval_min_long = editData.limit_sms_interval_min_long;
            _this.DATA.allow_registration_by_phone = editData.allow_registration_by_phone;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    return BrandsSmsCfgCtl;
}(BaseController_1.BaseController));
exports.BrandsSmsCfgCtl = BrandsSmsCfgCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_brands_list/ctl/BrandSmsCfgCtl.ts
// module id = 1033
// module chunks = 0